module.exports = __webpack_public_path__ + "static/media/super-search.6a56f406.png";